// extracted by mini-css-extract-plugin
module.exports = {"groupsCounter":"_1KMbbGlt","groupsCounterTooltip":"_29NWUbp7"};